var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.75,
    fill: "white",
    stroke: "#9C57A5",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 14.2222C17.9645 14.2222 19.5564 12.6303 19.5564 10.6667C19.5564 8.70299 17.9645 7.11111 16.0009 7.11111C14.0372 7.11111 12.4453 8.70299 12.4453 10.6667C12.4453 12.6303 14.0372 14.2222 16.0009 14.2222Z",
    fill: "#9C57A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1119 20.8889C23.1119 23.0978 23.1119 24.8889 16.0008 24.8889C8.88965 24.8889 8.88965 23.0978 8.88965 20.8889C8.88965 18.68 12.0736 16.8889 16.0008 16.8889C19.9279 16.8889 23.1119 18.68 23.1119 20.8889Z",
    fill: "#9C57A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImUser);
export default __webpack_public_path__ + "static/media/Im User.0c545f510d70abfb6e5fff887ac4b2d7.svg";
export { ForwardRef as ReactComponent };